<template>
  <div id="supplier-tour-list">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <h6>Active Tours</h6>
      </div>
    </div>

    <template v-if="tours">
      <div class="md=layout">
        <div class="md-layout-item md-size-100">
          <md-table>
            <md-table-row v-for="tour in tours" :key="tour.id">
              <md-table-cell>{{ tour.title }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["tours"]
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
#supplier-tour-list {
  margin-top: 1rem;
  border-top: 2px solid $brand-primary;
  padding-top: 1rem;

  .md-table-cell {
    padding: 4px 4px 4px 0;
    height: 36px;
  }

  h6,
  .h6 {
    margin: 0 0 0.5rem 0;
  }
}
</style>
